import { ActionReference, GameObjectReference, GameState, PlayerSessionShared } from "../../../shared/types";
import { LitElement, TemplateResult, css, html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { getState, performAction } from "../services/routeService";
import MapRoomsData from "../data/mapRoomsData.json";
import { bathroomDialogues } from "../library/dialogues/bathroom/bathroom";
import { DialogueHandler } from "../classes/class-room";
import { prologueFirstDialogues } from "../library/dialogues/prologue1/prologue1";
import { Dialogue } from "../types/game-GameCanvas";
import { prologueSecondDialogues } from "../library/dialogues/prologue2/prologue2";
import { MotelRoom666Dialogues } from "../library/dialogues/hotelroom-numbered/MotelRoom666";
import sendGetPlayerSessionRequest from "../services/Player/send-get-playersession-request";
import { helpOverlayText } from "../data/help-overlay";
import { hotelroomDialogues } from "../library/dialogues/hotelroom/hotelroom";
import { elevatorDialogues } from "../library/dialogues/elevator/elevator";
import { lobbyDialogues } from "../library/dialogues/lobby/lobby";
import { basementDialogues } from "../library/dialogues/basement/basement";
import sendSwitchRoomRequest from "../services/Player/send-switch-room-request";
import { controlroomDialogues } from "../library/dialogues/controlroom/controlroom";
import sendChangeStatusRequest from "../services/Player/send-status-change-request";

@customElement("game-canvas")
export class GameCanvas extends LitElement {
    // Property to switch from user login to game, different from the isInGame property
    @property() public isUserInGame: boolean = false;
    @property() public isGameMapOpen: boolean = false;
    @property() public inCurrentRoomId: number = NaN;
    // For the GameCanvas
    @property() public isInGame: boolean = false;
    // For the dialogue filter
    @property() public currentRoomDialogues: any[] = [];

    @state() private mainHeadText: string = "";
    // Possible states: action | dialogue
    @state() private currentDialogueState: string = "action";
    @state() private currentDialogueId: number = 1;
    // Store timer reference for frameLooper
    @state() private frameLoopTimer: any;
    // For open and close of the help menu (button)
    @state() private isHelpMenuOpen: boolean = false;
    // State if the "TO MAIN DIALOGUE" button is visable
    @state() private isGoToDialogueButtonVisable: boolean = false;
    // State for in talkAction
    @state() private isInTalkAction: boolean = false;

    public static styles = css`
        .game {
            height: 100vh;
            width: 100%;
            display: flex;
            flex-direction: column;
        }

        .title {
            text-align: center;
            display: flex;
            flex-direction: row;
        }

        .div-menubuttons-hitpoints {
            display: flex;
            flex-direction: row;
            width: 40%;
            justify-content: space-between;
            align-items: center;
        }

        .div-title_and_hitpoints {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            overflow: hidden;
        }

        .header-hitpoints {
            padding-left: 20px;
            margin: 0;
        }

        .div-menubuttons {
            display: flex;
            flex-direction: row;
            gap: 0.4em;
            max-height: 3em;
        }

        .menubutton {
            background-color: white;
            font-size: 1rem;
            background-color: gray;
            border: 4px black solid;
        }

        .main-screen {
            display: flex;
            flex-direction: column;
            justify-content: center;
            /* MAIN SCREEN HEIGHT, IMG (HEADER) + CONTENT TEXT BOX */
            height: 80vh;
        }

        .header {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex-grow: 1;
            position: relative;
            margin-top: 0px;
            overflow: hidden;
            width: 100%;
            height: 400px;
        }

        .header img {
            position: absolute;
            bottom: 0;
            object-fit: cover;
            object-position: bottom;
            width: 100%;
        }

        .header img:nth-child(n + 2) {
            position: absolute;
            bottom: -100px;
        }

        .main-div-map {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 1em;
            overflow-y: scroll;

            overflow-y: auto;
            scrollbar-gutter: stable;
            scrollbar-width: thin;
            scrollbar-color: darkgray transparent;
        }

        .room-button {
            border: 0;
            text-decoration: none;
            background-color: #0ea5e9;
            padding: 2em;
        }

        .room-button:hover {
            background-color: #0284c7;
        }

        .room-button:disabled {
            background-color: #94a3b8;
        }

        .content {
            flex-grow: 1;
            margin-top: 10px;
            padding: 0 10px;
            background-color: #27272a;
            color: white;
            width: 70%;
            /* font-family: "Shadows Into Light", cursive; */
            font-family: "Kalam", cursive;
            font-weight: 700;
            font-style: normal;

            overflow-y: auto;
            scrollbar-gutter: stable;
            scrollbar-width: thin;
            scrollbar-color: darkgray transparent;
        }

        .dialogue-box {
            /* CONTENT + DIALOGUE CHOICES */
            display: flex;
            flex-direction: row;
            height: 40vh;
        }

        .content p {
            padding: 1em;
            margin: 0 0 10px 0;
            font-size: 1.4rem;
            color: white;
        }

        .content p:last-of-type {
            margin: 0;
        }

        .div-dialogue-choices {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin: 10px 0 0 10px;
            background-color: gray;
            width: 30%;
        }

        .div-filtered-buttons {
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            padding: 1em;
            gap: 0.6em;
            width: 100%;
        }

        .div-filtered-buttons .button {
            box-sizing: border-box;
            background-color: #00000030;
            border: 2px solid #00000030;
            padding: 6px 10px;
            text-transform: uppercase;
            cursor: pointer;
            display: inline-block;
            user-select: none;
            font-size: 1rem;
            width: 100%;
            font-weight: 600;
            color: #fef08a;
        }

        .div-filtered-buttons .button:hover {
            background-color: #0000005C;
        }
        
        .button-dialogue-choice {
            border: none;
            padding: 0;
            margin: 0;
            background-color: transparent;
            cursor: pointer;
            padding-bottom: 0.2em;
            font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande", "Lucida Sans", Arial,
                sans-serif;
            font-weight: 400;
            color: #fef08a;
            font-size: 1.4rem;
            text-align: start;
        }

        .button-dialogue-choice:hover {
            color: white;
        }

        .button-dialogue-choice:disabled {
            color: darkgray;
        }

        .footer {
            box-sizing: border-box;
            border-radius: 10px 10px 0 0;
            background-color: black;
            padding-top: 10px;
            display: flex;
            height: 20vh;
        }

        .inventory {
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            background-color: burlywood;
            width: 63%;
            padding-left: 8px;
            margin: 0;
            padding-bottom: 8px;
        }

        .inventory-items-div {
            overflow-y: auto;
            margin-top: -12px;

            scrollbar-gutter: stable;
            scrollbar-width: thin;
            scrollbar-color: black wheat;
        }

        .inventory-items-div .button {
            font-weight: 600;
            font-size: 1.1rem;
        }

        .inventory-header {
            padding-left: 8px;
        }

        .to-dialogue-button {
            height: 100%;
            font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande", "Lucida Sans", Arial,
                sans-serif;
            font-weight: 700;
            font-size: 2rem;
        }

        .footer .buttons {
            display: flex;
            flex-direction: column;
            overflow: auto;
            padding: 10px 10px 0 10px;
        }

        .footer .button {
            background-color: wheat;
            border: 1px solid black;
            padding: 5px 10px;
            margin: 0 0 10px 10px;
            text-transform: uppercase;
            cursor: pointer;
            display: inline-block;
            user-select: none;
        }

        .main-head-text {
            color: white;
        }

        .ïntroduction-text {
            background-color: #1f2937;
            padding: 1em;
            height: 40vh;
            font-size: 1.4rem;
            font-weight: 600;
            color: #cbd5e1;
            text-align: center;
        }

        .actions-buttons {
            width: 37%;
            padding: 1em;
            background-color: darkred;
            overflow-y: auto;

            scrollbar-gutter: stable;
            scrollbar-width: thin;
            scrollbar-color: black transparent;
        }

        .actions-buttons .button {
            background-color: white;
            font-size: 1rem;
            background-color: gray;
            border: 4px black solid;
        }

        .action-button-icon {
            margin: 0;
            padding: 0;
            font-size: 2.4rem;
        }

        .div-action-button-icon {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 0.4em;
        }

        .action-button-label {
            font-size: 0.6rem;
        }

        .div-help-menu {
            display: flex;
            flex-direction: column;
            justify-content: center;
            box-sizing: border-box;
            background-color: rgba(0, 0, 0, 0.6);
            height: 85vh;
            max-width: 1080px;
            padding: 1em;
            position: absolute;
            inset: 0px;
            z-index: 50;
            margin-left: auto;
            margin-right: auto;
        }

        .div-help-menu p {
            box-sizing: border-box;
            padding: 1em;
            border-radius: 20px;
            background-color: #27272a;
            color: #e4e4e7;
            overflow-y: scroll;
            line-height: 1.2;
            font-size: 1.2rem;
            font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande", "Lucida Sans", Arial,
                sans-serif;
        }

        .div-help-menu ion-icon {
            display: flex;
            align-self: flex-end;
            background-color: transparent;
            color: white;
            font-size: 4rem;
            flex
        }
        
        .inputCode {
            display: flex;
            align-self: middle;
            margin: 0 auto; 
            text-align: center;
        }

        .inputCode:hover {
            background-color: #7f6ed7;
        }

        .inputCode:focus {
            background-color: #7f6ed7;
        }

        .footer .button.active,
        .footer .button:hover {
            background-color: #00000030;
        }

        .actions-buttons .button.active,
        .actions-buttons .button:hover {
            background-color: darkgray;
        }

        .hidden {
            display: none;
        }

    `;

    private roomTitle?: string;
    private roomImages?: string[];
    private contentText?: string[];
    private dialogueText: string = "";
    private actionButtons?: ActionReference[];
    private gameObjectButtons?: GameObjectReference[];

    private playerSession: PlayerSessionShared | null = null;
    private playerHitpoints?: number;

    private selectedActionButton?: ActionReference;
    private selectedGameObjectButtons: Set<GameObjectReference> = new Set<GameObjectReference>();

    private inputCode: string = "";

    public connectedCallback(): void {
        super.connectedCallback();

        void this.refreshState();
    }

    private async refreshState(): Promise<void> {
        const state: GameState = await getState();

        // Mitch: Gets the updated player session from the backend
        await this.getPlayerSession();
        // Mitch: Gets the current healthpoints from the game session
        this.getPlayerHealthpoints();

        console.log(state);

        this.updateState(state);
    }

    private updateState(state: GameState): void {
        //Reset the component
        this.roomTitle = state.roomTitle;
        this.roomImages = state.roomImages;
        this.contentText = state.text;
        this.actionButtons = state.actions;
        this.gameObjectButtons = state.objects;

        this.selectedActionButton = undefined;
        this.selectedGameObjectButtons.clear();

        // Checks if the player has started the game and sets isInGame to the right state
        this.checkPlayerInGame();

        // Sets the property of inCurrentRoomId and currentRoomDialogues to the active room from the back-end game state
        this.getCurrentActiveRoom();

        this.handleDialogueButtonVisible();

        this.requestUpdate();

        // Adds typewriter effect to loading in the right dialogue
        this.handleUpdateDialogue();
    }

    private async updateOjects(): Promise<void> {
        const state: GameState = await getState();

        this.actionButtons = state.actions;
        this.gameObjectButtons = state.objects;
        this.roomTitle = state.roomTitle;

        this.selectedActionButton = undefined;
        this.selectedGameObjectButtons.clear();

        await this.getPlayerSession();

        this.getPlayerHealthpoints();
    }

    private async updateContentTextState(): Promise<void> {
        const state: GameState = await getState();

        this.contentText = state.text;

        await this.getPlayerSession();

        this.getPlayerHealthpoints();
    }

    private async handleClickAction(button: ActionReference): Promise<void> {
        if (button.needsObject) {
            this.selectedActionButton = button;
            this.selectedGameObjectButtons.clear();

            const state: GameState = await getState();

            console.log(state);

            this.requestUpdate();
        } else {
            const state: any = await performAction(button.alias);

            if (state === undefined) {
                return;
            }

            if (button.alias === "start-game") {
                await this.refreshState();
            }

            this.updateState(state);

            // Makes sure the right room examine is always being triggered when entering
            if (this.inCurrentRoomId === 1) {
                await this.updateContentTextState();
            }

            // Adds typewriter effect to loading in the right dialogue
            this.handleUpdateDialogue();
        }
    }

    private async handleClickObject(button: GameObjectReference): Promise<void> {
        // Switches the to the action-dialogue screen FROM the possible dialogue-dialogue screen
        this.currentDialogueState = "action";

        if (!this.selectedActionButton) {
            return;
        }

        this.selectedGameObjectButtons.add(button);

        const state: GameState | undefined = await performAction(
            this.selectedActionButton.alias,
            [...this.selectedGameObjectButtons].map((e) => e.alias)
        );

        if (this.selectedGameObjectButtons.size >= 2) {
            this.selectedActionButton = undefined;
            this.selectedGameObjectButtons.clear();
        }

        this.requestUpdate();

        if (state === undefined) {
            return;
        }

        await this.handleInputCode();

        this.updateState(state);
    }

    // ROOT RENDER
    // ROOT RENDER
    // ROOT RENDER
    protected render(): TemplateResult {
        return html`
            <div class="game">
                <div class="main-screen">
                    ${this.isHelpMenuOpen
                        ? html`<div class="div-help-menu">
                              <ion-icon name="close" @click=${(): void => this.handleClickHelp()}></ion-icon>
                              <p>${helpOverlayText}</p>
                          </div>`
                        : null}
                    ${this.renderTitle()} ${this.renderHeader()}
                    ${this.playerSession?.inputVissible === true &&
                    this.inCurrentRoomId === 20 &&
                    !this.isGameMapOpen
                        ? this.renderInputCode()
                        : null}

                    <div class="dialogue-box">
                        ${this.currentDialogueState === "action"
                            ? html`${this.renderContent()}${this.isInGame
                                  ? html`${this.renderSwtchDialogueScreenButton()}`
                                  : null}`
                            : this.renderDialogueAndChoices()}
                    </div>
                </div>
                ${this.renderFooter()}
            </div>
        `;
    }

    // Render for the top title, including the player's hitpoints and this.mainHeadText.
    private renderTitle(): TemplateResult {
        if (this.roomTitle) {
            return html`
                <div class="div-title_and_hitpoints">
                    <h3 class="main-head-text">${this.mainHeadText}</h3>
                    ${this.inCurrentRoomId === 0
                        ? null
                        : html`
                              <div class="div-menubuttons-hitpoints">
                                  ${this.renderMenuButtons()}
                                  <h3 class="main-head-text header-hitpoints">
                                      Hitpoints: ${this.playerHitpoints}
                                  </h3>
                              </div>
                          `}
                </div>
            `;
        }

        return html`${nothing}`;
    }

    // Render for the header image and switch with player map.
    private renderHeader(): TemplateResult {
        if (this.roomImages && this.roomImages.length > 0) {
            return html`
                <div class="header">
                    ${this.isGameMapOpen
                        ? html`<div class="main-div-map">
                              ${MapRoomsData.map((room) => {
                                  return html`
                                      <button
                                          ?disabled=${this.isRoomLocked(room.roomId)}
                                          class="room-button"
                                          @click=${async (): Promise<void> =>
                                              await this.handleClickRoomOnMap(room.roomId)}
                                      >
                                          ${room.roomName}
                                      </button>
                                  `;
                              })}
                          </div>`
                        : html`
                              ${this.roomImages?.map(
                                  (url) => html`<img class="header-image" src="/assets/img/rooms/${url}" /> `
                              )}
                          `}
                </div>
            `;
        }

        return html`${nothing}`;
    }

    //input code room 666
    private renderInputCode(): TemplateResult {
        return html`<input @change=${this.setInputCode} type="text" class="inputCode" id="submitCodeID" />
            <button @click=${this.checkInputCode} class="inputCode" id="submitCode">Submit</button>`;
    }

    private setInputCode(event: InputEvent): void {
        this.inputCode = (event.target as HTMLInputElement).value;
    }

    public async handleInputCode(): Promise<void> {
        await this.getPlayerSession();

        if (this.inCurrentRoomId === 5) {
            if (this.playerSession?.inputVissible === true) {
                await this.refreshState();
            }
        }
    }

    private async checkInputCode(): Promise<void> {
        if (this.inputCode === "231930") {
            if (!this.playerSession) {
                return;
            }
            // await sendSwitchRoomRequest("6");
            await this.handleClickRoomOnMap(6);
            await sendChangeStatusRequest("inputvissible", false);
            await sendChangeStatusRequest("completedHallway666", true);
        }
        if (!this.playerSession) {
            return;
        }
        this.playerSession.inputVissible = false;
        this.requestUpdate();
    }

    private renderContent(): TemplateResult {
        return html`<div class="content">
            ${this.contentText?.map(() => html`<p id="backend-dialogue"></p>`)}
        </div>`;
    }

    // Filters the array of the current room to required dialogue const from .ts file.
    public dialogueFilter(dialogueId: number): any[] {
        // Filters all the room's dialogue to match the right dialogue to the required dialogue from a choice made
        const result: any[] = this.currentRoomDialogues.filter((item) => item.id === dialogueId);

        return result;
    }

    // Set ?disable of an option to a condition of choice, for example a player status.
    private isChoiceDisabled(choiceId: number, roomId: number): boolean {
        // HOW TO USE:
        // Minimum requuired:
        // 1/4 STATUS CONDITION
        // 2/4 this.currentDialoId equal to dialogue of the choice,
        // 3/4 choiceId equal to the choiceId to disable in your dialogue object,
        // 4/4 roomId needs to be the Id of your room you want to disable an option in, bathroom for example is id 3.

        // EXAMPLE USE: After either pick-up or useage of the door-knob, the option to pick-up becomes disabled.
        if (
            (this.playerSession?.inventory.includes("door-knob") || this.playerSession?.hasUsedDoorKnob) &&
            this.currentDialogueId === 6 &&
            choiceId === 2 &&
            roomId === 3
        ) {
            return true;
        }

        if (
            (this.playerSession?.inventory.includes("bathroom-towel") ||
                this.playerSession?.hasCleanedHands) &&
            this.currentDialogueId === 6 &&
            choiceId === 3 &&
            roomId === 3
        ) {
            return true;
        }

        if (
            this.playerSession?.inventory.includes("pocket-knife") &&
            this.currentDialogueId === 5 &&
            choiceId === 1 &&
            roomId === 1
        ) {
            return true;
        } else if (
            !this.playerSession?.inventory.includes("pocket-knife") &&
            this.currentDialogueId === 5 &&
            choiceId === 2 &&
            roomId === 1
        ) {
            return true;
        }

        if (
            !this.playerSession?.inventory.includes("flashlight-item") &&
            this.currentDialogueId === 3 &&
            choiceId === 2 &&
            roomId === 9
        ) {
            return true;
        }

        if (
            this.playerSession?.hasNoticedCamera &&
            this.currentDialogueId === 31 &&
            choiceId === 2 &&
            roomId === 3
        ) {
            return true;
        }

        return false;
    }

    // Handles what needs to happen after a dialogue choice has been clicked
    public async handleDialogueOptionClick(choiceId: number, currentDialogueId: number): Promise<void> {
        // Dialogue choices handler class
        const dialogueHandlerClass: DialogueHandler = new DialogueHandler();

        let result: number;
        // Sends the chosen option to the right function in the class and gets the result of which dialogue to load in.
        switch (this.inCurrentRoomId) {
            case 1:
                if (this.playerSession?.completedPrologueFirst === false) {
                    // Room is prologue first
                    result = await dialogueHandlerClass.handleDialoguesPrologueFirst(
                        choiceId,
                        currentDialogueId
                    );
                } else {
                    // ON RETURN AFTER COMPLETION
                    result = await dialogueHandlerClass.handleDialoguesPrologueFirstReturn(
                        choiceId,
                        currentDialogueId
                    );
                }

                break;

            case 2:
                if (this.playerSession?.completedPrologueSecond === false) {
                    // Room is prologue second
                    result = await dialogueHandlerClass.handleDialoguesPrologueSecond(
                        choiceId,
                        currentDialogueId
                    );
                } else {
                    // ON RETURN AFTER COMPLETION
                    result = await dialogueHandlerClass.handleDialoguesPrologueSecondReturn(
                        choiceId,
                        currentDialogueId
                    );
                }

                break;

            case 3:
                // Handles switching the dialogues to when a player returns to a room thats's been completed
                if (this.playerSession?.completedBathroom === false) {
                    // Room is: Bathroom, hasn't completed the room yet
                    result = await dialogueHandlerClass.handleDialoguesBathroom(choiceId, currentDialogueId);
                } else {
                    // Player completed the bathroom and returns to it
                    result = await dialogueHandlerClass.handleDialoguesBathroomReturn(
                        choiceId,
                        currentDialogueId
                    );
                }
                break;

            case 9:
                // Room is: The Basement
                result = await dialogueHandlerClass.handleDialoguesBasement(choiceId, currentDialogueId);
                break;

            default:
                result = await dialogueHandlerClass.handleDialoguesPrologueFirst(choiceId, currentDialogueId);
        }

        // Result is the id of the dialogue that needs to be shown
        this.currentDialogueId = result;

        // In the class dialogue handler, when returning dialogue with id === 99, go to the given room.
        if (this.currentDialogueId === 99) {
            await this.refreshState();
            // Sets the dialogueId to the first of the dialogue array after switching rooms
            this.currentDialogueId = 1;
            return;
        }

        // Filters to the right dialogue to retreive the correct dialogue-object from the dialogue-handler
        const currentDialogueArray: any[] = this.dialogueFilter(this.currentDialogueId);
        // Sets the property of of shown dialogue text to the filtered assigned dialogue
        this.dialogueText = currentDialogueArray[0].dialogue;
        // Updates the required states
        await this.updateOjects();
        // Renders the correct dialogue to the display
        this.handleUpdateDialogue();
    }

    // Render for the dialogue and choices interface.
    public renderDialogueAndChoices(): TemplateResult {
        // Filter to always receive the object that belongs to current dialogue
        const currentDialogue: any[] = this.currentRoomDialogues.filter(
            (item) => item.id === this.currentDialogueId
        );

        const dialogue: Dialogue = currentDialogue[0];

        return html`<div class="content">
                <p id="main-dialogue"></p>
            </div>
            ${html`<div class="div-dialogue-choices">
                <ul>
                    ${dialogue
                        ? dialogue.options.map((option: { id: number; action: string; roomId: number }) => {
                              return html`<li>
                                  <button
                                      ?disabled=${this.isChoiceDisabled(option.id, option.roomId)}
                                      class="button-dialogue-choice"
                                      @click=${async (): Promise<void> =>
                                          this.handleDialogueOptionClick(option.id, dialogue.id)}
                                  >
                                      ${option.action}
                                  </button>
                              </li>`;
                          })
                        : null}
                </ul>
            </div> `}`;
    }

    // Render for the button to switch from the action results render to the dialogue render.
    private renderSwtchDialogueScreenButton(): TemplateResult {
        if (this.roomImages && this.roomImages.length > 0) {
            return html`
                <div class="div-dialogue-choices">
                    ${this.isGoToDialogueButtonVisable
                        ? html`<button
                              class="to-dialogue-button"
                              @click=${(): void =>
                                  // Switches the to the action-dialogue screen FROM the possible dialogue-dialogue screen
                                  this.handleSwitchDialogueMenu()}
                          >
                              CONTINUE MAIN <br />
                              DIALOGUE
                          </button>`
                        : html`<div class="div-filtered-buttons">
                              ${this.actionButtons?.map(
                                  (button) =>
                                      html`<a
                                          class="${button.label === "Use" ||
                                          button.label === "Examine" ||
                                          button.label === "Start Game" ||
                                          button.label === "Pickup" ||
                                          button.label === "Talk To"
                                              ? "hidden"
                                              : "button"}"
                                          @click=${(): void => void this.handleClickAction(button)}
                                          >${this.renderActionButtonIcons(button.label)}</a
                                      >`
                              )}
                          </div>`}
                </div>
            `;
        }

        return html`${nothing}`;
    }

    // Render for the "Main meny" and "Player map" buttons included in the footer render.
    private renderMenuButtons(): TemplateResult {
        if (this.roomImages && this.roomImages.length > 0) {
            return html`
                <div class="div-menubuttons">
                    ${this.isInGame
                        ? html` <button type="button" class="menubutton">
                              <ion-icon
                                  class="action-button-icon"
                                  name="map-outline"
                                  @click=${(): void => this.handleClickMap()}
                              ></ion-icon>
                          </button>`
                        : null}

                    <button type="button" class="menubutton" ?disabled=${true}>
                        <ion-icon class="action-button-icon" name="menu-outline"></ion-icon>
                    </button>

                    ${this.isInGame
                        ? html` <button type="button" class="menubutton">
                              <ion-icon
                                  class="action-button-icon"
                                  name="help-circle-outline"
                                  @click=${(): void => this.handleClickHelp()}
                              ></ion-icon>
                          </button>`
                        : null}
                </div>
            `;
        }

        return html`${nothing}`;
    }

    // Render for the footer, including the action buttons and player inventory.
    private renderFooter(): TemplateResult {
        return html`
            <div class="footer">
                <div class="actions-buttons">
                    ${this.actionButtons?.map(
                        (button) =>
                            html`<a
                                class="${button.label === "Use" ||
                                button.label === "Examine" ||
                                button.label === "Start Game" ||
                                button.label === "Pickup" ||
                                button.label === "Talk To"
                                    ? "button "
                                    : "hidden"} ${this.selectedActionButton === button ? "active" : ""}"
                                @click=${(): void => void this.handleClickAction(button)}
                                >${this.renderActionButtonIcons(button.label)}</a
                            >`
                    )}
                </div>
                ${this.isInGame === true
                    ? html`<div class="inventory">
                          <h3 class="inventory-header">Environment</h3>
                          <div class="inventory-items-div">
                              ${this.gameObjectButtons?.map(
                                  (button) =>
                                      html`<a
                                          class="button"
                                          @click=${(): void => void this.handleClickObject(button)}
                                          >${button.name}</a
                                      >`
                              )}
                          </div>
                      </div>`
                    : null}
            </div>
        `;
    }

    private renderActionButtonIcons(itemLabel: string): TemplateResult {
        if (itemLabel === "Use") {
            return html`<div class="div-action-button-icon">
                <ion-icon class="action-button-icon" name="hand-right-outline"></ion-icon>
                <label class="action-button-label" for="hand-right-outline">Use</label>
            </div> `;
        }

        if (itemLabel === "Examine") {
            return html`<div class="div-action-button-icon">
                <ion-icon class="action-button-icon" name="eye-outline"></ion-icon>
                <label class="action-button-label" for="eye-outline">Examine</label>
            </div>`;
        }

        if (itemLabel === "Pickup") {
            return html`<div class="div-action-button-icon">
                <ion-icon class="action-button-icon" name="share-outline"></ion-icon>
                <label class="action-button-label" for="share-outline">Pick Up</label>
            </div>`;
        }

        if (itemLabel === "Talk To") {
            return html`<div class="div-action-button-icon">
                <ion-icon class="action-button-icon" name="chatbubbles-outline"></ion-icon>
                <label class="action-button-label" for="chatbubbles-outline">Talk To</label>
            </div>`;
        }

        return html`${itemLabel}`;
    }

    // State for opening and closing the main menu.
    public handleClickBackToMainMenu(): void {
        // Value to set start screen in the parent.
        this.isUserInGame = false;
        this.dispatchEvent(new Event("go-mainmenu"));
    }

    private isRoomLocked(roomButtonId: number): boolean {
        if (this.playerSession?.currentRoom === "basement") {
            return true;
        }

        if (this.playerSession?.completedPrologueFirst === true && roomButtonId === 1) {
            return false;
        }

        if (this.playerSession?.completedPrologueFirst === true && roomButtonId === 2) {
            return false;
        }

        if (this.playerSession?.completedPrologueSecond === true && roomButtonId === 3) {
            return false;
        }

        if (this.playerSession?.completedBathroom === true && roomButtonId === 4) {
            return false;
        }

        if (this.playerSession?.completedBathroom === true && roomButtonId === 19) {
            return false;
        }

        if (this.playerSession?.completedHallway === true && roomButtonId === 5) {
            return false;
        }

        if (this.playerSession?.completedHotelroomNumbered === true && roomButtonId === 20) {
            return false;
        }

        if (this.playerSession?.completedHallwayNumbered === true && roomButtonId === 6) {
            return false;
        }

        if (this.playerSession?.completedElevator === true && roomButtonId === 7) {
            return false;
        }

        if (this.playerSession?.completedLobby === true && roomButtonId === 8) {
            return false;
        }

        return true;
    }

    // State for opening and closing the player map.
    public handleClickMap(): void {
        // Opens the map with all the rooms.
        if (this.isGameMapOpen === true) {
            this.isGameMapOpen = false;
        } else if (this.isGameMapOpen === false) {
            this.isGameMapOpen = true;
        }
    }

    // State for opening and closing the help menu.
    public handleClickHelp(): void {
        // Opens the map with all the rooms.
        if (this.isHelpMenuOpen === true) {
            this.isHelpMenuOpen = false;
        } else if (this.isHelpMenuOpen === false) {
            this.isHelpMenuOpen = true;
        }
    }

    // Handle clicking on a room on the player map.
    public async handleClickRoomOnMap(roomId: number): Promise<void> {
        // Handles switching the current player's session current to the appointed room.
        await sendSwitchRoomRequest(`${roomId}`);

        // Refreshes the entire state to begin the render from the beginning,
        // with main focus on seeing the new current room of the player's session
        await this.refreshState();

        // Gets and sets currentRoomId to the current room.
        this.getCurrentActiveRoom();

        this.handleDialogueButtonVisible();

        // Makes sure the correct dialogueId is given on first arrival aswell as return to a room
        this.handleReturnToRoomDialogue();

        // Closes the game map on selected room click.
        this.isGameMapOpen = false;
    }

    // Typewriter effect, renders in per letter to the innerHTML of the right elements.
    private handleUpdateDialogue(): void {
        if (!this.contentText) {
            console.log(this.contentText, this.dialogueText);
            return;
        }

        let shadow: Element | null | undefined;
        let rawDialogueTextInput: string | undefined;

        switch (this.currentDialogueState) {
            case "action":
                shadow = this.shadowRoot?.querySelector("#backend-dialogue");
                rawDialogueTextInput = this.contentText[0];
                break;

            case "dialogue":
                shadow = this.shadowRoot?.querySelector("#main-dialogue");
                rawDialogueTextInput = this.dialogueText[0];
                break;
        }

        if (!rawDialogueTextInput) {
            return;
        }

        if (!shadow) {
            setTimeout(() => this.handleUpdateDialogue(), 100); // Retry after 100ms
            return;
        }

        // Stop the current frameLooper if running
        if (this.frameLoopTimer) {
            clearTimeout(this.frameLoopTimer);
        }

        // Resets the dialogue box to be empty
        shadow.textContent = "";

        const splitArray: any[] = rawDialogueTextInput.split("");
        if (!splitArray) {
            return;
        }

        // Preprocess splitArray to replace "<" with "<br><br>" to handle double line breaks
        // Preprocess splitArray to replace ">" with "<br>" to handle a single line break
        // Preprocess splitArray to replace "[" with "<span>" to handle text bold entry
        // Preprocess splitArray to replace "]" with "</span>" to handle text bold exit
        let insideBrackets: boolean = false;
        let textInsideBrackets: string = "";

        for (let i: number = 0; i < splitArray.length; i++) {
            if (splitArray[i] === "<") {
                splitArray[i] = "<br><br>";
            } else if (splitArray[i] === ">") {
                splitArray[i] = "<br>";
            } else if (splitArray[i] === "[") {
                splitArray[i] = "*";
                insideBrackets = true;
            } else if (splitArray[i] === "]") {
                insideBrackets = false;
                splitArray[i] = "*";
                // console.log(textInsideBrackets);
                // textInsideBrackets = "";
            } else {
                if (insideBrackets) {
                    textInsideBrackets += splitArray[i];
                }
            }
        }

        // sets speed of text writing in animation
        const frameLooper: any = (textSpeed: number): void => {
            this.frameLoopTimer = setTimeout(() => frameLooper(textSpeed), textSpeed);

            if (splitArray.length > 0) {
                if (!shadow) {
                    clearTimeout(this.frameLoopTimer);
                    return;
                }

                // Fills the dialogue box with the processed text
                shadow.innerHTML += splitArray.shift();
            } else {
                clearTimeout(this.frameLoopTimer);
            }
        };

        frameLooper(8);
    }

    // Handles triggering the first dialogue without a player choice clicked.
    private handleReturnToRoomDialogue(): void {
        let result: number = 1;
        // Sends the chosen option to the right function in the class and gets the result of which dialogue to load in.
        switch (this.inCurrentRoomId) {
            case 1:
                // Room is prologue first
                if (this.playerSession?.completedPrologueFirst === false) {
                    result = 1;
                } else {
                    result = 7;
                }
                break;

            case 2:
                // Room is prologue second
                if (this.playerSession?.completedPrologueSecond === false) {
                    result = 1;
                } else {
                    result = 1;
                }
                break;

            case 3:
                // Handles switching the dialogues to when a player returns to a room thats's been completed
                if (this.playerSession?.completedBathroom === false) {
                    result = 1;
                } else {
                    result = 30;
                }
                break;

            case 4:
                // Room is: The hotelroom
                if (this.playerSession?.completedHotelroom === false) {
                    result = 1;
                } else {
                    result = 1;
                }
                break;

            case 19:
                // Room is: Hallway 666
                if (this.playerSession?.completedHotelroom === false) {
                    result = 1;
                } else {
                    result = 1;
                }
                break;

            case 20:
                // Room is: Hallway 666
                if (this.playerSession?.completedHotelroomNumbered === false) {
                    result = 1;
                } else {
                    result = 1;
                }
                break;

            case 5:
                // Room is: The hotelroom 666
                if (this.playerSession?.completedHotelroomNumbered === false) {
                    result = 1;
                } else {
                    result = 1;
                }
                break;

            case 6:
                // Room is: The elevator
                if (this.playerSession?.completedElevator === false) {
                    result = 1;
                } else {
                    result = 1;
                }
                break;

            case 7:
                // Room is: The lobby
                if (this.playerSession?.completedLobby === false) {
                    result = 1;
                } else {
                    result = 1;
                }
                break;

            case 8:
                // Room is: The security-room
                if (this.playerSession?.completedSecurityRoom === false) {
                    result = 1;
                } else {
                    result = 1;
                }
                break;

            case 9:
                // Room is: The Basement
                // Is always result = 1
                result = 1;
                break;
        }

        this.currentDialogueId = result;

        const filteredResult: any[] = this.dialogueFilter(this.currentDialogueId);
        this.dialogueText = filteredResult[0].dialogue;

        this.requestUpdate();
    }

    // Handle clicking the "Continue the main dialogue" button.
    private handleSwitchDialogueMenu(): void {
        if (this.currentDialogueState === "dialogue") {
            this.currentDialogueState = "action";

            this.requestUpdate();
        } else if (this.currentDialogueState === "action") {
            this.currentDialogueState = "dialogue";

            // Makes sure the initial dialogue without an option choice gets rendered
            if (this.inCurrentRoomId !== 0 || !this.dialogueText) {
                const result: any = this.dialogueFilter(this.currentDialogueId);
                this.dialogueText = result[0].dialogue;
            }

            this.requestUpdate();

            // Triggers the typewriter effect switching to the dialogue menu
            this.handleUpdateDialogue();
        }
    }

    // Sets the players hitpoints.
    private getPlayerHealthpoints(): number | undefined {
        // Mitch created property of tracking the current player's hitpoints
        if (this.playerSession) {
            this.playerHitpoints = this.playerSession.hitpoints;
        }

        return this.playerHitpoints;
    }

    // Get the current player session and stash it inside a property
    private async getPlayerSession(): Promise<void> {
        // Mitch created property of tracking the current playerSession
        this.playerSession = await sendGetPlayerSessionRequest();
    }

    // Checks if player has started the game by looking at the rooms picture. (Change later if enough time)
    private checkPlayerInGame(): boolean | undefined {
        if (this.roomImages === undefined) {
            return undefined;
        }

        if (this.roomTitle === "Startup Room") {
            this.inCurrentRoomId = 0;
            this.currentRoomDialogues = [];
            return (this.isInGame = false);
        } else {
            return (this.isInGame = true);
        }
    }

    private handleDialogueButtonVisible(): boolean {
        if (this.actionButtons) {
            function inTalkAction(actionButtons: ActionReference[]): boolean {
                const result: number = actionButtons.filter((item) => item.alias.includes("talk:")).length;

                if (result > 0) {
                    return true;
                } else {
                    return false;
                }
            }

            this.isInTalkAction = inTalkAction(this.actionButtons);
        }

        if (
            this.inCurrentRoomId === 0 ||
            this.inCurrentRoomId === 4 ||
            this.inCurrentRoomId === 5 ||
            this.inCurrentRoomId === 6 ||
            this.inCurrentRoomId === 7 ||
            this.inCurrentRoomId === 8 ||
            this.inCurrentRoomId === 19 ||
            this.inCurrentRoomId === 20 ||
            (this.playerSession?.currentRoom === "bathroom" &&
                this.playerSession.completedBathroom &&
                this.playerSession.hasNoticedCamera &&
                this.isInTalkAction)
        ) {
            // Is "TO MAIN DIALOGUE BUTTON" visible state handling
            return (this.isGoToDialogueButtonVisable = false);
        } else {
            return (this.isGoToDialogueButtonVisable = true);
        }
    }

    // Gets and sets the current room property in this component, also sets the default dialogueId to 1.
    private getCurrentActiveRoom(): void {
        switch (this.playerSession?.currentRoom) {
            // Resets the dialogues when the player dies and lands on the start up room.
            case "startup":
                this.mainHeadText = "Welcome to the game";
                this.inCurrentRoomId = 0;
                this.currentDialogueId = 1;
                break;

            case "prologue-first":
                this.mainHeadText = "Home - Cleveland, Ohio";
                this.currentRoomDialogues = prologueFirstDialogues;
                this.inCurrentRoomId = 1;
                break;

            case "prologue-second":
                this.mainHeadText = "A forest road - At night - Somewhere in ohio";
                this.currentRoomDialogues = prologueSecondDialogues;
                this.inCurrentRoomId = 2;
                break;

            case "bathroom":
                this.mainHeadText = "A bathroom - Somewhere";
                this.currentRoomDialogues = bathroomDialogues;
                this.inCurrentRoomId = 3;

                this.currentDialogueState = "action";
                break;

            case "hallway-room":
                this.mainHeadText = "A hotel hallway - Somewhere";
                this.currentRoomDialogues = hotelroomDialogues;
                this.inCurrentRoomId = 19;
                break;

            case "motelhallway666":
                this.mainHeadText = "A hotel hallway - Somewhere";
                this.currentRoomDialogues = hotelroomDialogues;
                this.inCurrentRoomId = 20;
                break;

            case "room":
                this.mainHeadText = "A hotelroom - Somewhere";
                this.currentRoomDialogues = hotelroomDialogues;
                this.inCurrentRoomId = 4;
                break;

            case "motelroom666":
                this.mainHeadText = "A hotelroom (666) - Somewhere";
                this.currentRoomDialogues = MotelRoom666Dialogues;
                this.inCurrentRoomId = 5;
                break;

            case "elevator":
                this.mainHeadText = "An elevator - Somewhere";
                this.currentRoomDialogues = elevatorDialogues;
                this.inCurrentRoomId = 6;
                break;

            case "lobby":
                this.mainHeadText = "A hotel lobby - Somewhere";
                this.currentRoomDialogues = lobbyDialogues;
                this.inCurrentRoomId = 7;
                break;

            case "control":
                this.mainHeadText = "A security room - Somewhere";
                this.currentRoomDialogues = controlroomDialogues;
                this.inCurrentRoomId = 8;
                break;

            case "basement":
                this.mainHeadText = "The basement - Somewhere";
                this.currentRoomDialogues = basementDialogues;
                this.inCurrentRoomId = 9;
                break;
        }

        // Sets the dialogue to the action menu when entering a new room.
        this.currentDialogueState = "action";
    }
}

// ROOM ID's
// Startup room: 0
// Prologue 1: 1
// Prologue 2: 2
// Bathroom: 3
// Hotelroom: 4
// Room666: 5
// Elevator: 6
// Lobby: 7
// Security room: 8
// Basement: 9

// EXTRA:
// Hallway243: 19
// MotelHallway666: 20
